<template lang="html">
  <div class="container-lg">
    <div class="row">
      <div class="col-md-12 mt-3">
        <div class="card">
          <div class="card-body">
            <h2>Finde deine perfekte Ausbildung – mit KI-Unterstützung.</h2>
            <h3>Du hast viele Fragen. Wir haben die Antworten.</h3>
            <br />
            <p>
              Welcher Beruf passt wirklich zu dir? Was macht dir Spaß? Wo kannst
              du deine Stärken einsetzen? Unsere App hilft dir, diese Fragen zu
              beantworten – ehrlich, individuell und ohne Druck.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6 mt-3">
        <div
          class="card"
          style="cursor: pointer"
          v-on:click="PushTo('/signin')"
          id="loginUser"
        >
          <div class="card-body text-center">
            <font-awesome-icon
              :icon="['fas', 'right-from-bracket']"
              class="fa-5x"
              style="color: #198fcf"
            />
          </div>
          <div class="text-center">Bin schon dabei - lasst mich rein!</div>
        </div>
      </div>

      <div class="col-sm-12 col-md-6 mt-3">
        <div
          class="card"
          style="cursor: pointer"
          v-on:click="PushTo('/signup')"
          id="addUser"
        >
          <div class="card-body text-center">
            <font-awesome-icon
              :icon="['fas', 'user-plus']"
              class="fa-5x"
              style="color: #198fcf"
            />
          </div>
          <div class="text-center">Ich bin neu!</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6 mt-3" v-if="false">
        <div class="card">
          <div
            class="card-body text-center"
            style="cursor: pointer"
            v-on:click="PushTo('/companySignin')"
          >
            <font-awesome-icon
              :icon="['fas', 'building-circle-arrow-right']"
              class="fa-5x"
              style="color: #bc0101"
            />
            <fa class="fa-5x" icon="building" style="color: #bc0101" />
          </div>
          <div class="text-center">Anmeldung Firmen</div>
        </div>
      </div>

      <div class="col-sm-12 col-md-6 mt-3" v-if="false">
        <div
          class="card"
          style="cursor: pointer"
          v-on:click="PushTo('/companySignUp')"
        >
          <div class="card-body text-center">
            <font-awesome-icon
              :icon="['fas', 'fa-plus']"
              class="fa-5x"
              style="color: #bc0101"
            />
          </div>
          <div class="text-center">Wir sind neu!</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 mt-3">
        <div class="card">
          <div class="card-body">
            <h3>So funktioniert’s:</h3>
            <br />
            <ol>
              <li>
                48 einfache Fragen.
                <br />
                Keine falschen Antworten – nur ehrliche Einblicke in deine
                Persönlichkeit.
              </li>
              <li>
                Intelligente Auswertung
                <br />
                Unsere KI analysiert deine Antworten und erkennt, welche Berufe
                wirklich zu dir passen.
              </li>
              <li>
                Individuelle Empfehlungen
                <br />
                Du erhältst eine Liste passender Ausbildungsberufe – abgestimmt
                auf deine Interessen, Stärken und Werte.
              </li>
              <li>
                Berufe entdecken
                <br />
                Tauche in spannende Berufswelten ein, die du vielleicht noch gar
                nicht auf dem Schirm hattest – aber perfekt zu dir passen.
              </li>
            </ol>
            <br />
            <h3>Warum unsere App?</h3>
            <ul>
              <li>
                <b>Persönlich:</b> Du stehst im Mittelpunkt – nicht deine Noten.
              </li>
              <li>
                <b>Einfach:</b> Kein komplizter Test, sondern ein Gespräch über
                dich.
              </li>
              <li>
                <b>Zukunftssicher:</b> Mit KI-Technologie entwickelst du deinen
                eigenen Karriereweg.
              </li>
              <li>
                <b>Inspirierend:</b> Entdecke Ausbildungsberufe, die zu dir UND
                deiner Zukunft passen.
              </li>
            </ul>
            <br />
            <h3>Starte jetzt - kostenlos und anonym</h3>
            <p>
              Mach den ersten Schritt in deine berufliche Zukunft. Finde heraus,
              was wirklich zu dir passt – ganz ohne Druck, ohne Bewerbung und
              ohne Erwartungen.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      password: null,
    };
  },
  methods: {
    PushTo(route) {
      // Avoid redundant navigation to current location error - check also main.js router.beforeEach-section

      try {
        this.$router.push(route);
      } catch (error) {
        if (!(error instanceof NavigationDuplicated)) {
          throw error;
        }
      }
    },
  },
};
</script>
